var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"video"},[_c('iframe',{attrs:{"src":_vm.videoClass?.path,"frameborder":"0","width":"100%","height":"550","allow":"autoplay; encrypted-media","webkitallowfullscreen":"","mozallowfullscreen":"","allowfullscreen":""}})])
}
var staticRenderFns = []

export { render, staticRenderFns }